export const consultingAnalysis = {
    title: 'Client management',
    list: {
        detailTitle: '分析パラメーター',
        title: 'コンサル分析履歴',
        usage_or_client_folder: 'PJ名',
        theme_name: 'テーマ名',
        patent_count: '特許件数見込み',
        patent_period_start: '分析対象特許の出願年期間_始点',
        patent_period_end: '分析対象特許の出願年期間_終点',
        investment_period_start: '投資デ-タの分析対象期間_始点',
        investment_period_end: '投資デ-タの分析対象期間_終点',
        ipc_digit: '分析対象IPC"/"後桁数',
        one_cluster_one_ipc: '1クラスタ1IPCモ-ド要否',
        is_cvc: 'is_cvc',
        created_date: '作成日時',
        status: {
            title: 'ステータス',
            pending: '保留中',
            analysis: '分析中',
            success: '成功',
            failed: '失敗',
            undefined: 'NULL'
        },
        id: 'DL',
        databricks_url: 'ログURL',
        parameters_str: 'パラメーター',
        user_name: '実行者',
        parameters_str_button: '表示',
        copyParameters: 'パラメーターをコピー',
        copySuccess: 'コピーしました',
        copyFailed: 'コピーに失敗しました',
        searchAll: 'すべて検索',
        userInputPlaceholder: 'キーワードを入力してください'
    },
    upload: {
        title: 'アップロード',
        pageTitle: 'RAW_DATA アップロード',
        parametersLabel: 'パラメーター',
        parametersPlaceholder: 'コンサル管理シートの1行を貼り付けてください',
        selectZipLabel: 'RAW_DATA のZIPファイル を選択',
        confirmTitle: '入力内容の確認',
        back: '戻る',
        submit: '送信',
        processingButton: '処理中…',
        processing: 'サーバーで処理中です…しばらくお待ちください',
        uploadComplete: 'アップロードが完了しました',
        leavePageWarning: '処理中です。ページを離れますか？',
        error: {
            selectZip: 'ZIP ファイルを選択してください',
            enterParameters: 'パラメーターを入力してください',
            emptyClientFolder: 'PJ名が空です',
            emptyThemeName: 'テーマ名が空です',
            invalidPatentCount: '特許件数見込みが数値ではありません',
            invalidPatentPeriodStart: '分析対象特許の出願年期間_始点のフォーマットが不正です',
            invalidPatentPeriodEnd: '分析対象特許の出願年期間_終点のフォーマットが不正です',
            invalidInvestmentPeriodStart: '投資データの分析対象期間_始点のフォーマットが不正です',
            invalidInvestmentPeriodEnd: '投資データの分析対象期間_終点のフォーマットが不正です',
            invalidIpcDigit: '分析対象IPC後桁数が不正です',
            invalidOneClusterOneIpc: '1クラスタ1IPCモード要否が不正です',
            invalidIsCvc: 'バリューチェーン分析モードの値が不正です',
            networkError:
                '通信中にエラーが発生しました。回線状況が不安定な場合に発生することがあります。回線状況をご確認の上、再度お試しください。解決しない場合は開発チームにご連絡ください。'
        },
        chooseFile: 'ファイルを選択',
        noFileSelected: 'ファイルが選択されていません',
        fileSelectNote: '※ファイル選択後、読み込みに少し時間がかかる場合があります'
    }
}
